import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import { UserService } from '../services/user.service';
import Notiflix from "notiflix";
import { meetingAction, AgendaDetails } from '../models/MOMForm';
import { MasterMOMService } from '../services/master-mom.service';

import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { pairText } from '../models/users';
import { AdminService } from '../services/admin.service';
@Component({
  selector: 'app-meeting-action',
  templateUrl: './meeting-action.component.html',
  styleUrls: ['./meeting-action.component.css'],
  providers: [ToastrUtilsService]
})
export class MeetingActionComponent implements OnInit {
  noDataImage: any;
  login_UserID: any;
  meetingActionList: any = [];
  isLoader: boolean = false;
  filterVal = new meetingAction();
  filterCount: number = 0;
    forMe: boolean;
    today: boolean;
    tommorrow: boolean;
  older: boolean;
  modalMeeting: BsModalRef;
  mid: any;
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  modalfilterRef: BsModalRef;
    delay: boolean;
    strK1: string;
    strI1: string;
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    private userService: UserService,
    private modalService: BsModalService,
    public momMasterservice: MasterMOMService,
    private _router: Router,
    public restApi: AdminService) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.login_UserID = user.id;
    } 
    this.loadpairText();
    this.loadMeetingAction();
    setTimeout(function () {
    var elementElBacktoTop = document.getElementById('filter') as HTMLInputElement;
    if (elementElBacktoTop != null) {
      elementElBacktoTop.style.display = "block";
      }
    }, 100);
  }

  openModalnewMeeting(template1: TemplateRef<any>, item) {
    ;
    this.mid = item.genInfoUno;
    this.modalMeeting = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, this.ngbModalOptions)
    );
  }
  loadFilterValues() {
    this.filterCount = 0;
    if (this.filterVal.forMe) {
      this.forMe = true;
      this.filterCount = this.filterCount + 1;
    }
    else {
      this.forMe = false;
    }
    if (this.filterVal.forToday) {
      this.today = true;
      this.filterCount = this.filterCount + 1;
    }
    else {
      this.today = false;
    }
    if (this.filterVal.forTommorrow) {
      this.tommorrow = true;
      this.filterCount = this.filterCount + 1;
    }
    else {
      this.tommorrow = false;
    }
    if (this.filterVal.forOlder) {
      this.older = true;
      this.filterCount = this.filterCount + 1;
    }
    else {
      this.older = false;
    }
    if (this.filterVal.forDelay) {
      this.delay = true;
      this.filterCount = this.filterCount + 1;
    }
    else {
      this.delay = false;
    }
    this.loadMeetingAction()
  }
  clearAllFilter() {
    this.forMe = false;
    this.today = false;
    this.tommorrow = false;
    this.older = false;
    this.delay = false;

    this.filterVal.forMe = false;
    this.filterVal.forToday = false;
    this.filterVal.forTommorrow = false;
    this.filterVal.forOlder = false;
    this.filterVal.forDelay = false;

    this.filterCount = 0;
    this.loadFilterValues();
  }
  loadMeetingAction() {
    //Notiflix.Block.Dots('.pageloadcontainer');
    this.isLoader = true;
    this.filterVal.userUno = this.login_UserID;
    this.momMasterservice.getMeetingActionAll(this.filterVal)
      .subscribe(data => {
        ;
        this.isLoader = false;
        if (data != null && data != undefined) {

          let dataList: any = [];
          dataList = data;
          this.meetingActionList = dataList;
          console.log("meetingAction", this.meetingActionList );
        }
        else {
          this.meetingActionList = [];
        }
        
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
        
      },
        (error) => {
          this.isLoader = false;
          
         // Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
    ).add(() => {
      this.isLoader = false;
       // Notiflix.Block.Remove('.pageloadcontainer', 800);
      });
  }
  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  
  redirectMeetingActionList(type: any) {
    

    this._router.navigate(['/meetingactionlist'], { queryParams: { QType: btoa(type) } });
  }

  openFilter(modalfilter: TemplateRef<any>) {
    this.modalfilterRef = this.modalService.show(modalfilter, Object.assign({}, { class: 'gray modal-lg modal-dialog-scrollable' }, this.ngbModalOptions));
    //this.modalfilterRef.hide();
  }

  ResolveConfirm(data: any,progress:number) {
    ;
    let temp = this;
    Notiflix.Confirm.Show('Confirm', 'Are you sure you want to resolve this action?', 'Yes', 'No', function () {

      temp.isLoader = true;
      temp.ResolveTask(data, progress);

    }, function () { // No button callback
      return false;
    });

  }
  ResolveTask(data1: any, progress:number) {
   
    let obj = new AgendaDetails();
    obj.agendaUno = data1.agendaUno;
    obj.userID = this.login_UserID;
    obj.progress = progress;
    this.momMasterservice.resolveTask(obj)
      .subscribe((data: any) => {
        if (data == 'success') {
          this.loadMeetingAction();
          this.toastr.SuccessCustomMessage();

          this.isLoader = false;
        }

        else {
          this.toastr.ErrorMessage();
          this.isLoader = false;
        }
        // this.spinner.hide();
      },
        () => {
          this.toastr.ErrorMessage();
         
          this.isLoader = false;
        
          //Called when error
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }

  removeTags(str) {
    ;
    if ((str === null) || (str === ''))
      return str;
    else
      str = str.toString();
    str = str.replace(/(<([^>]+)>)/ig, '');
    var strr = str.replace('&amp;', '');
    var strreplace = strr.replace('&nbsp;', '');
    return strreplace;

  }
  exportXL() {
    ;
    let items1: any = [];
    let items2: any = [];
    let items3: any = [];
    if (this.meetingActionList.lstMOMMeetingAction_DueToday != null && this.meetingActionList.lstMOMMeetingAction_DueToday != undefined) {
      for (var i = 0; i < this.meetingActionList.lstMOMMeetingAction_DueToday.length; i++) {
      items1.push({
        Ref_Number: this.meetingActionList.lstMOMMeetingAction_DueToday[i].agendaUno,
        Note: this.removeTags(this.meetingActionList.lstMOMMeetingAction_DueToday[i].note),
        Subject: this.meetingActionList.lstMOMMeetingAction_DueToday[i].subjectAtd,
        DueDate: formatDate(this.meetingActionList.lstMOMMeetingAction_DueToday[i].dueDate, 'MM/dd/yyyy', 'en-US'),
        Location: this.meetingActionList.lstMOMMeetingAction_DueToday[i].location,
        Initiator: this.meetingActionList.lstMOMMeetingAction_DueToday[i].userName,
        Progress: this.meetingActionList.lstMOMMeetingAction_DueToday[i].progress == 0 ? 'Not Started' : this.meetingActionList.lstMOMMeetingAction_DueToday[i].progress == 1 ? 'In Progress' : this.meetingActionList.lstMOMMeetingAction_DueToday[i].progress == 2 ? 'Completed' : this.meetingActionList.lstMOMMeetingAction_DueToday[i].progress == 3 ? 'Waiting on others' : 'Deferred'
      });
      }
    }
    if (this.meetingActionList.lstMOMMeetingAction_LaterThisWeek != null && this.meetingActionList.lstMOMMeetingAction_LaterThisWeek != undefined) {
      for (var i = 0; i < this.meetingActionList.lstMOMMeetingAction_LaterThisWeek.length; i++) {
        items2.push({
          Ref_Number: this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].agendaUno,
          Note: this.removeTags(this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].note),
          Subject: this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].subjectAtd,
          DueDate: formatDate(this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].dueDate, 'MM/dd/yyyy', 'en-US'),
          Location: this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].location,
          Initiator: this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].userName,
          Progress: this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].progress == 0 ? 'Not Started' : this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].progress == 1 ? 'In Progress' : this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].progress == 2 ? 'Completed' : this.meetingActionList.lstMOMMeetingAction_LaterThisWeek[i].progress == 3 ? 'Waiting on others' : 'Deferred'
        });
      }
    }
    if (this.meetingActionList.lstMOMMeetingAction_DueTomorrow != null && this.meetingActionList.lstMOMMeetingAction_DueTomorrow != undefined) {
      for (var i = 0; i < this.meetingActionList.lstMOMMeetingAction_DueTomorrow.length; i++) {
        items3.push({
          Ref_Number: this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].agendaUno,
          Note: this.removeTags(this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].note),
          Subject: this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].subjectAtd,
          DueDate: formatDate(this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].dueDate, 'MM/dd/yyyy', 'en-US'),
          Location: this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].location,
          Initiator: this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].userName,
          Progress: this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].progress == 0 ? 'Not Started' : this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].progress == 1 ? 'In Progress' : this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].progress == 2 ? 'Completed' : this.meetingActionList.lstMOMMeetingAction_DueTomorrow[i].progress == 3 ? 'Waiting on others' : 'Deferred'
        });
      }
    }
    let allItems = items1.concat(items2, items3);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(allItems);
    const workbook: XLSX.WorkBook = { Sheets: { 'Meeting': worksheet }, SheetNames: ['Meeting'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, 'MeetingActionPointList.xlsx');


  }

}
